import React, { useState } from 'react'
import { useEffect } from 'react';
import { Button } from 'react-bootstrap';
import { Table, Checkbox } from 'rsuite';
import Swal from 'sweetalert2';
import queueService from '../../../services/Internal/Queue/queue.service';
import entityService from '../../../services/Internal/Staff/entity.service';
import LoadingSpinner from '../../Shared/GenericComponents/LoadingSpinner';
import GenericPagination from '../../Shared/Grid/GenericPagination';
import { sort_by } from './../../Shared/HelperFunctions'

function UnassignedTasksGrid({ propsIsActive, viewItemCallback }) {
    const [gridData, setGridData] = useState([]);
    const [hasLoaded, setHasLoaded] = useState(false);
    const [hasGridLoad, setHasGridLoad] = useState(false);
    const [sortColumn, setSortColumn] = useState("dateSubmitted");
    const [sortType, setSortType] = useState("asc");
    const [displayLength, setDisplayLength] = useState(20);
    const [page, setPage] = useState(1);
    const [employeeList, setEmployeeList] = useState({});
    const CheckCell = ({ rowData, onChange, checkedKeys, dataKey, ...props }) => (
        <Table.Cell {...props} style={{ padding: 0 }}>
            <div style={{padding: '10px' }}>
                <Checkbox
                    value={rowData[dataKey]}
                    inline
                    onChange={onChange}
                    checked={checkedKeys.some(item => item === rowData[dataKey])}
                />
            </div>
        </Table.Cell>
    );
    useEffect(() => {

        if (propsIsActive) {
            setHasLoaded(false);
            refreshGrid();
            setHasLoaded(true);
            setHasGridLoad(true);
            entityService.plsGetStaffAndAdmin(true).then((response) => {
                var staffList = {};
                response.data.map((item, i) => {
                    staffList[`${item.id}`] = `${item.firstName} ${item.lastName}`;
                })
                setEmployeeList(staffList);
            });
        }
        //the reason that this is in a set timeout is because without this databind delay, the column width calculations with flexgrow would be wrong
        //We will need to test with a C# controller call and see if the get request delay that happens will be enough to have the columns recalculate their widths
    }, [propsIsActive])

    const refreshGrid = () => {
        queueService.getUnassignedTasks().then((response) => {
            setGridData(response.data);
            setCheckedKeys([]);
        });
    }

    const getData = () => {

        var sortedData = gridData.sort(sort_by(sortColumn, sortType !== "asc"));
        return sortedData.filter((v, i) => {
            const start = displayLength * (page - 1);
            const end = start + displayLength;
            return i >= start && i < end;
        })
    }

    const handleSortColumn = (sortColumn, sortType) => {

        setSortColumn(sortColumn);
        setSortType(sortType);
    }

    const filteredData = getData();

    const [checkedKeys, setCheckedKeys] = useState([]);
    let checked = false;
    let indeterminate = false;
    const formDataListAppender = (passedKey, model, formData) => {
        for (let key in model) {
            if (typeof (model[key]) === 'object') {
                formDataListAppender(`${passedKey}[${key}]`, model[key], formData); // Recursive key for objects
            }
            else {
                if (passedKey)
                    formData.append(`${passedKey}[${key}]`, model[key]);
                else
                    formData.append(`${key}`, model[key]);
            }
        }
    }
    if (checkedKeys.length === filteredData.length) {
        checked = true;
    } else if (checkedKeys.length === 0) {
        checked = false;
    } else if (checkedKeys.length > 0 && checkedKeys.length < filteredData.length) {
        indeterminate = true;
    }

    const handleCheckAll = (value, checked) => {
        const keys = checked ? filteredData.map(item => item.taskId) : [];
        setCheckedKeys(keys);
    };
    const handleCheck = (value, checked) => {
        const keys = checked ? [...checkedKeys, value] : checkedKeys.filter(item => item !== value);
        setCheckedKeys(keys);
    };
    function handleBulkAssignClick() {
        if (checkedKeys.length > 0) {
            Swal.fire({
                title: 'Assign To',
                input: 'select',
                inputOptions: { ...employeeList },
                inputPlaceholder: 'Select a Reviewer',
                showCancelButton: true,
                confirmButtonText: 'Save',
                showLoaderOnConfirm: true,
                allowOutsideClick: () => !Swal.isLoading(),
                inputValidator: (value) => {
                    return value === "" && 'Select a Reviewer!'
                }
            }).then((result) => {
                if (result.isConfirmed && result.value !== '') {
                    var formData = new FormData();
                    formDataListAppender('taskIds', checkedKeys, formData);
                    formData.append('userId', result.value);
                    queueService.bulkPostAssignTasks(formData).then((response) => {
                        if (response.status == 200) {
                            if (response.data.didSave) {
                                let unassignedTasksMessage = "";
                                if (response.data.data.length > 0) {
                                    unassignedTasksMessage = "<b>With the exception of these already assigned tasks:</b><br/><br/><ul>";
                                    var alreadyAssignedTasks = filteredData.filter(task => response.data.data.includes(task.taskId)).map((value, i) => {
                                        return `<li style="text-align: left;">${value.applicant}'s<br/><b>${value.parentType} - ${value.taskType}</b></li><br/>`;
                                    })
                                    unassignedTasksMessage += alreadyAssignedTasks.join("");
                                    unassignedTasksMessage += "</ul>";
                                }
                                setHasGridLoad(false);
                                refreshGrid();
                                Swal.fire({ title: "Successfully assigned", html: unassignedTasksMessage, didClose: () => { setHasGridLoad(true); } });
                            }
                            else {
                                // Did not save because something happened and it rollbacked the transaction
                                Swal.fire(response.data.Message);
                            }
                        }
                    })
                }
                else {
                    if (!result.value && result.isConfirmed) {
                        Swal.fire("Selected dropdown list item's value is empty")
                    }
                }
            })
        }
        else {
            Swal.fire("No queue items were selected.");
        }
    }
    return (
        <>
            {
                hasLoaded ?
                    <>
                        <Button variant="dark" onClick={handleBulkAssignClick}>Bulk Assign</Button>
                        <GenericPagination page={page} dataLength={gridData.length} displayLength={displayLength} setDisplayLength={setDisplayLength} setPage={setPage} discludeAllLength={false} />
                        <Table
                            headerHeight={60}
                            loading={!hasGridLoad}
                            onSortColumn={(sortColumn, sortType) => { handleSortColumn(sortColumn, sortType) }}
                            sortColumn={sortColumn}
                            sortType={sortType}
                            wordWrap autoHeight data={filteredData}>
                            <Table.Column width={50} fixed>
                                <Table.HeaderCell>
                                    <div style={{ lineHeight: '40px' }}>
                                        <Checkbox
                                            inline
                                            checked={checked}
                                            indeterminate={indeterminate}
                                            onChange={handleCheckAll}
                                        />
                                    </div>
                                </Table.HeaderCell>
                                <CheckCell dataKey="taskId" checkedKeys={checkedKeys} onChange={handleCheck} />
                            </Table.Column>
                            <Table.Column width={200} fixed>
                                <Table.HeaderCell />
                                <Table.Cell dataKey="id">
                                    {rowData => {
                                        function handleViewClick() {
                                            viewItemCallback(rowData);
                                        }
                                        function handleAssignClick() {
                                            Swal.fire({
                                                title: 'Assign To',
                                                input: 'select',
                                                inputOptions: { ...employeeList },
                                                inputPlaceholder: 'Select a Reviewer',
                                                showCancelButton: true,
                                                confirmButtonText: 'Save',
                                                showLoaderOnConfirm: true,
                                                allowOutsideClick: () => !Swal.isLoading(),
                                                inputValidator: (value) => {
                                                    return value === "" && 'Select a Reviewer!'
                                                }
                                            }).then((result) => {
                                                if (result.isConfirmed && result.value !== '') {
                                                    queueService.postAssignTask(rowData.taskId, result.value).then((response) => {
                                                        if (response.status == 200) {
                                                            if (typeof (response.data) == "string" && response.data.startsWith("This task is already assigned to")) {
                                                                Swal.fire({
                                                                    title: 'Reassign?',
                                                                    text: response.data,
                                                                    showCancelButton: true,
                                                                    confirmButtonText: 'Reassign',
                                                                    showLoaderOnConfirm: true,
                                                                    allowOutsideClick: () => !Swal.isLoading(),
                                                                }).then((reassignResult) => {
                                                                    if (reassignResult.isConfirmed) {
                                                                        queueService.reassignTask(rowData.taskId, result.value).then((response) => {
                                                                            if (response.status == 200) {
                                                                                Swal.fire({ title: "Successfully reassigned" });
                                                                            }
                                                                        })
                                                                    }
                                                                    setHasGridLoad(false);
                                                                    refreshGrid();
                                                                    setHasGridLoad(true);
                                                                })
                                                            }
                                                            else {
                                                                setHasGridLoad(false);
                                                                refreshGrid();
                                                                Swal.fire({ title: "Successfully assigned", didClose: () => { setHasGridLoad(true); } });
                                                            }
                                                        }
                                                    })
                                                }
                                                else {
                                                    if (!result.value && result.isConfirmed) {
                                                        Swal.fire("Selected dropdown list item's value is empty")
                                                    }
                                                }
                                            })
                                        }
                                        return (
                                            <>
                                                <Button className="me-1" onClick={handleViewClick}>View</Button>
                                                <Button variant="dark" onClick={handleAssignClick}>Assign</Button>
                                            </>
                                        );
                                    }}
                                </Table.Cell>
                            </Table.Column>
                            <Table.Column minWidth={100} flexGrow={1} sortable>
                                <Table.HeaderCell>
                                    <b>Applicant</b>
                                </Table.HeaderCell>
                                <Table.Cell dataKey="applicant" />
                            </Table.Column>
                            <Table.Column minWidth={150} flexGrow={1.7} sortable>
                                <Table.HeaderCell>
                                    <b>Application Type</b>
                                </Table.HeaderCell>
                                <Table.Cell dataKey="taskType">{rowData => (`${rowData.parentType} - ${rowData.taskType}`)}</Table.Cell>
                            </Table.Column>
                            <Table.Column minWidth={150} flexGrow={.5} sortable>
                                <Table.HeaderCell>
                                    <b>Date Submitted</b>
                                </Table.HeaderCell>
                                <Table.Cell dataKey="dateSubmitted">{rowData => (new Date(rowData.dateSubmitted).toLocaleDateString())}</Table.Cell>
                            </Table.Column>
                            <Table.Column minWidth={100} flexGrow={.5} sortable>
                                <Table.HeaderCell>
                                    <b>Internal Status</b>
                                </Table.HeaderCell>
                                <Table.Cell dataKey="internalStatus" />
                            </Table.Column>
                            <Table.Column minWidth={100} flexGrow={1} sortable>
                                <Table.HeaderCell>
                                    <b>Comment(s)</b>
                                </Table.HeaderCell>
                                <Table.Cell dataKey="comments" />
                            </Table.Column>
                            <Table.Column minWidth={100} flexGrow={.5} sortable>
                                <Table.HeaderCell>
                                    <b>Status</b>
                                </Table.HeaderCell>
                                <Table.Cell dataKey="parentStatus" />
                            </Table.Column>
                        </Table>
                        <GenericPagination page={page} dataLength={gridData.length} displayLength={displayLength} setDisplayLength={setDisplayLength} setPage={setPage} discludeAllLength={false} />
                    </>
                    : <LoadingSpinner />
            }
        </>
    );
}

export default UnassignedTasksGrid;